import {Component} from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-modal-detalhes-erro',
  templateUrl: './modal-detalhes-erro.component.html',
  styleUrls: ['./modal-detalhes-erro.component.scss']
})
export class ModalDetalhesErroComponent {
  titulo: string = 'Detalhes do Erro';
  sistema: string = '';
  pedido: string = '';
  erro: string = '';
  dataHora: string = '';
  erroCopiado: boolean = false;

  constructor(private dialogRef: DialogRef) {}

  fechar() {
    this.dialogRef.close();
  }

  copiarErro() {
    const texto = `Sistema: ${this.sistema}\nPedido: ${this.pedido}\nData/Hora: ${this.dataHora}\n\nErro:\n${this.erro}`;
    
    if (navigator.clipboard) {
      navigator.clipboard.writeText(texto).then(() => {
        this.mostrarSucessoCopiado();
      }).catch(() => {
        this.fallbackCopyTextToClipboard(texto);
      });
    } else {
      this.fallbackCopyTextToClipboard(texto);
    }
  }

  private mostrarSucessoCopiado() {
    this.erroCopiado = true;
    setTimeout(() => {
      this.erroCopiado = false;
    }, 2000); // Volta ao estado normal após 2 segundos
  }

  private fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.mostrarSucessoCopiado();
    } catch (err) {
      console.error('Erro ao copiar texto: ', err);
    }
    
    document.body.removeChild(textArea);
  }
}
